exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".calculated-values-container > div {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin: 2px 0px; }\n\n.calculated-values-container span {\n  color: transparent;\n  background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);\n  background-size: 200% 100%;\n  border-radius: 4px;\n  animation: skeleton-loading 1.5s linear infinite; }\n\n@keyframes skeleton-loading {\n  0% {\n    background-position: 200% 0; }\n  100% {\n    background-position: -200% 0; } }\n", ""]);

// exports
